<template>
  <div>
    <v-hover>
      <v-avatar :size="200" color="grey lighten-4" slot-scope="{ hover }">
        <v-img :src="imageUrl ? imageUrl : ''" alt="avatar">
          <v-expand-transition>
            <div v-if="hover" class="v-card--reveal grey darken-2 title white--text pt-3" style="height: 40%">
              <v-icon dark @click="pickFile" large>cloud_upload</v-icon>
            </div>
          </v-expand-transition>
        </v-img>
      </v-avatar>
    </v-hover>
    <input type="file" :accept="accept" style="display: none" ref="image" @change="onFilePicked" />
  </div>
</template>

<script>
export default {
  props: {
    value: File,
    accept: {
      type: String,
      default: 'image/*',
    },
    selectedCallback: Function,
    required: Boolean,
    className: String,
    imageDefault: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    imageName: '',
    imageFile: '',
    imageUrl: '',
  }),
  watch: {
    value(val) {
      if (!val) this.reset();
    },
    imageDefault(val) {
      this.imageUrl = val;
    },
  },
  computed: {},
  methods: {
    pickFile() {
      this.$refs.image.click();
    },
    reset() {
      console.log('reset upload');
      this.imageName = '';
      this.imageFile = '';
      this.imageUrl = '';
      this.$emit('input', null);
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files && files[0]) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }

        const reader = new FileReader();

        reader.addEventListener('load', () => {
          this.imageUrl = reader.result;
        });
        reader.readAsDataURL(files[0]);

        this.imageFile = files[0];

        this.$emit('input', this.imageFile);

        if (this.selectedCallback) {
          if (e.target.files[0]) {
            this.selectedCallback({
              imageUrl: this.imageUrl,
              imageFile: this.imageFile,
              imageName: this.imageName,
            });
          } else {
            this.selectedCallback(null);
          }
        }
      }
    },
  },
  mounted() {},
  created() {
    this.imageUrl = this.imageDefault ? this.imageDefault : '';
  },
};
</script>

<style lang="scss" scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.7;
  position: absolute;
  width: 100%;
}
</style>
